import 'material-symbols/outlined.css'
function Icon({ name, className }) {
  return (
    <span className={"material-symbols-outlined align-middle select-none " + className} translate={"no"}>
        {name}
    </span>
  );
}

export default Icon;